import type { Deployment } from './gen/ai/h2o/mlops/deployer/v2/deployment_pb';
import {
  AuthenticationPassphrase_HashAlgorithm,
  AuthorizationAccessToken_AuthorizationProtocolSecurityType,
} from './gen/ai/h2o/mlops/deployer/v2/security_pb';

export type SecurityKey =
  | 'NO_SECURITY'
  | AuthenticationPassphrase_HashAlgorithm
  | AuthorizationAccessToken_AuthorizationProtocolSecurityType;

export const getSecurityKey = (deployment: Deployment): SecurityKey => {
  const { security } = deployment;
  if (!security || `disabledSecurity` in security) return 'NO_SECURITY';
  if (`passphrase` in security) return security.passphrase!.hashAlgorithm;
  if (`tokenAuth` in security) return security.tokenAuth!.authenticationProtocol;
  // All the oneof unions were tested, so this should be unreachable and ideally verified by TypeScript in higher version
  throw new Error(`Unknown security type`);
};
